import SetUpWelPage from './container';

export default SetUpWelPage;



// WEBPACK FOOTER //
// ./src/views/Setup/WelcomePage/index.js